import { render } from "./CreditorList.vue?vue&type=template&id=09762673"
import script from "./CreditorList.vue?vue&type=script&lang=js"
export * from "./CreditorList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__